// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  margin-top: 125px;

  h1 {
    background: linear-gradient(
      141deg,
      #fca4ff -30%,
      rgba(97, 0, 202, 0.9) 100%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-family: SF Pro Display;
    font-size: 120px;
    font-style: normal;
    font-weight: 400;
    line-height: 106.8%; /* 128.16px */
    letter-spacing: -6px;
    margin-bottom: 50px;
    height: 270px;
  }

  svg {
    width: 100%;
    margin-left: -46px;
  }

  @media (max-width: 992px) {
    margin: 50px 0px 0px 0px;

    svg {
      margin-left: 0px;
    }
  }

  @media (max-width: 768px) {
    margin: 50px 0px 0px 0px;

    h1 {
      font-size: 100px;
      font-style: normal;
      font-weight: 400;
      line-height: 93.836%;

      width: 100%;
      height: fit-content;
      padding-bottom: 12px;
    }

    svg {
      margin-left: -20px;
      width: 110%;
    }
  }
`;
